import Web3 from 'web3';
import contractAbi from './abi_factory.json';

export const Factory = async (nomePropriedade, nomeProprietario, cnpjcpf, carArray, file_manager_contract_id) => {  
  let signer;
  let signature;
  let hashedMessage;

  try {
    if (!window.ethereum) {
      throw new Error("No crypto wallet found. Please install it.");
    }

    // Valida se carArray é um array
    if (!Array.isArray(carArray)) {
      throw new Error("carArray deve ser um array de códigos CAR");
    }

    // Valida se o array não está vazio
    if (carArray.length === 0) {
      throw new Error("É necessário fornecer pelo menos um código CAR");
    }

    // Valida cada elemento do array
    carArray.forEach((car, index) => {
      if (typeof car !== 'string' || car.trim() === '') {
        throw new Error(`Código CAR na posição ${index} é inválido`);
      }
    });

    // Inicializa Web3
    const web3 = new Web3(window.ethereum);
    
    await window.ethereum.request({ method: "eth_requestAccounts" });
    
    const accounts = await web3.eth.getAccounts();
    signer = accounts[0];

    const chainId = await window.ethereum.request({ method: "eth_chainId" });
    console.log("chainId", chainId);

    // Encode do mesmo jeito que o Solidity: abi.encode(string,string,string,abi.encode(car),string)
    const carEncoded = web3.eth.abi.encodeParameter('string[]', carArray);
    const encoded = web3.eth.abi.encodeParameters(
      ['string', 'string', 'string', 'bytes', 'string'],
      [nomePropriedade, nomeProprietario, cnpjcpf, carEncoded, file_manager_contract_id]
    );

    hashedMessage = web3.utils.keccak256(encoded);

    // Assina mensagem de hash
    signature = await window.ethereum.request({
      method: "personal_sign",
      params: [hashedMessage, signer],
    });

    // Configurando contrato
    const defaultContractAddress = "0x5f58053f00ac33e2557368daca06bab5f2ae0049";
    const manualAddress = window.prompt(
      "Informe o endereço do contrato Factory deployado (0x...)",
      defaultContractAddress
    );
    if (!manualAddress || !manualAddress.trim()) {
      throw new Error("Endereço do contrato Factory é obrigatório.");
    }
    const contractAddress = manualAddress.trim();

    const code = await web3.eth.getCode(contractAddress);
    console.log("Factory bytecode:", code === "0x" ? "NO CODE" : `OK len=${code.length}`);
    if (code === "0x") {
      throw new Error("Endereço ou rede errados. Não há bytecode nesse endereço.");
    }

    const contract = new web3.eth.Contract(contractAbi, contractAddress);

    console.log(
      "ABI functions:",
      contractAbi.filter(x => x.type === "function").map(x => `${x.name}(${x.inputs.map(i => i.type).join(",")})`)
    );
    console.log(
      "contract.methods keys:",
      Object.keys(contract.methods).filter(k => k !== "0")
    );

    if (typeof contract.methods.Factory !== "function") {
      throw new Error("ABI/contrato não possui método Factory; verifique nome real e ABI atualizado.");
    }

    console.log(
      "ABI Factory():",
      contractAbi.find(x => x.type === "function" && x.name === "Factory")?.inputs
    );

    const owner = await contract.methods.owner().call();
    console.log("FACTORY owner():", owner);
    console.log("SIGNER:", signer);

    if (owner.toLowerCase() !== signer.toLowerCase()) {
      throw new Error(`onlyOwner: signer (${signer}) != owner (${owner}). Troque de conta no MetaMask ou redeploy com essa conta.`);
    }

    // Definição de gas (pode precisar de mais gas para múltiplos CARs)
    const gasPrice = await web3.eth.getGasPrice();
    let gasLimit;

    try {
      // Chamada ao contrato com array de CARs
      // Você precisa ajustar o método do contrato para aceitar array
      const txMethod = contract.methods.Factory(
        nomePropriedade,
        nomeProprietario,
        cnpjcpf,
        carArray, // Passando o array diretamente
        file_manager_contract_id,
        signature
      );

      try {
        const estimatedGas = await txMethod.estimateGas({ from: signer });
        gasLimit = Math.ceil(estimatedGas * 1.2); // buffer de 20%
      } catch (estimateError) {
        // Fallback: gas fixo com base no número de CARs
        gasLimit = Math.ceil(6721975 * (1 + carArray.length * 0.1));
      }

      try {
        await txMethod.call({ from: signer });
        console.log("✅ CALL OK (não reverte)");
      } catch (e) {
        console.error("❌ CALL REVERT:", e);
        console.error("❌ REVERT reason:", e?.data?.message || e?.message);
        throw new Error(e?.data?.message || e?.message || "CALL revert");
      }

      const transaction = await txMethod.send({ from: signer, gas: gasLimit, gasPrice: gasPrice });
      
      // Extrair array de CARs do evento (pode vir como array ou string)
      let carArrayFromEvent = carArray; // Fallback para o array original
      if (transaction.events.NovoContrato.returnValues.car) {
        // Se vier como array do evento
        if (Array.isArray(transaction.events.NovoContrato.returnValues.car)) {
          carArrayFromEvent = transaction.events.NovoContrato.returnValues.car;
        }
      }
      
      return {
        transaction: transaction,
        contratoAddress: transaction.events.NovoContrato.address,
        contratoClienteAddress: transaction.events.NovoContrato.returnValues.contratoAddress,
        signerGeral: signer,
        file_manager_contract_id: transaction.events.NovoContrato.returnValues.file_manager_contract_id,
        signature: signature,
        hashedMessage: hashedMessage,
        carArray: carArrayFromEvent // Array de CARs registrados na blockchain
      };
    } catch (sendError) {
      console.error("SEND ERROR RAW:", sendError);
      const msg =
        sendError?.data?.message ||
        sendError?.message ||
        JSON.stringify(sendError);
      throw new Error(msg);
    }

  } catch (err) {
    let errorMessage = err?.message || err?.mensagem || '';

    // Tratamento específico para falhas de gas
    if (errorMessage.includes("gas required exceeds allowance")) {
      errorMessage = "Erro: O gas definido é insuficiente. Aumente o valor do gas.";
    } else if (errorMessage.includes("out of gas")) {
      errorMessage = "Erro: A transação ficou sem gas. Tente um valor maior.";
    } else if (errorMessage.includes("insufficient funds")) {
      errorMessage = "Erro: Saldo insuficiente para pagar as taxas de transação.";
    }

    console.error("Erro detectado:", errorMessage);

    const error = {
      message: errorMessage,
      mensagem: errorMessage,
      signer: signer,
      signature: signature,
      hashedMessage: hashedMessage,
      carArray: carArray
    };
    console.error("Detalhes do erro:", error);
    throw error;
  }
};